import { uniqBy, groupBy } from 'lodash'
import moment from 'moment'
import DURATIONS from '../../../constants/durations'
/*
const conflict = {
    date,
    hourId,
    durationId,
    courseIds: [ {} ]
}
*/
const mapConflicts = (courses = []) => {
    const conflicts = []
    courses = courses.map(c => ({...c, date: moment(c.date).toISOString()}))
    courses = uniqBy(courses, 'id' )
    const dateMap = groupBy(courses, 'date')
    const dateGroups = Object.values(dateMap).filter(dateGroup => dateGroup.length > 1)
    //console.log('dateGroups:', dateMap)
    dateGroups.forEach(dateGroup => {
        const hourMap = groupBy(dateGroup, 'hourId')
        const hourGroups = Object.values(hourMap).filter(hourGroup => hourGroup.length > 1)
        //console.log('hourGroups:', hourGroups)
        hourGroups.forEach(hourGroup => {
            if (hourGroup.some(course => course.durationId === DURATIONS.FULL)) {
                //console.log('some have full')
                //  Whole group is issue if there is one full duration
                const conflict = { courseIds: []}
                hourGroup.forEach(course => {
                    conflict.date = course.date
                    conflict.hourId = course.hourId
                    //conflict.durationId = course.durationId
                    conflict.courseIds.push(course.id)
                })
                conflicts.push(conflict)
            } else {
                //  Find matching durations
                const durationGroups = groupBy(hourGroup, 'durationId')
                Object.values(durationGroups)
                    .filter(durationGroup => durationGroup.length > 1)
                    .forEach(durationGroup => {
                        const conflict = { courseIds: []}
                        durationGroup.forEach(course => {
                            conflict.date = course.date
                            conflict.hourId = course.hourId
                            //conflict.durationId = course.durationId
                            conflict.courseIds.push(course.id)
                        })
                        conflicts.push(conflict)
                    })
            }
            
        })
    })
    
    //console.log('conflicts:', conflicts)
    return conflicts
}

export default mapConflicts
